module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-3200.887ca838.svg";